module.exports = __webpack_public_path__ + "img/stripe-background.f08254ad.webp";